import request from "@/utils/request";

/**
 * 撤销注单
 *
 * @description 用户注单详情撤销注单
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function cancleBettingRecord(playload) {
  return request({
    url: "/api/lottery/betting/cancleBettingRecord",
    method: "POST",
    data: playload,
    userId: true
  });
}
/**
 * 投注明细接口
 *
 * @description 获取彩票投注明细信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryBettingInfoById(playload) {
  return request({
    url: "/api/lottery/betting/queryBettingInfoById",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
    // loading: true
  });
}
/**
 * 投注记录接口
 *
 * @description 获取彩票投注记录列表信息
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function queryBettingInfoList(playload) {
  return request({
    url: "/api/lottery/betting/queryBettingInfoList",
    method: "POST",
    data: playload,
    userId: true,
    noEncrypt: true
  });
}
/**
 * 聊天室投注单跟单请求
 *
 * @description 聊天室投注单跟单请求
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function follow(playload) {
  return request({
    url: "/api/v2/betting/follow",
    method: "POST",
    data: playload,
    userId: true
  });
}

/**
 *
 * @description  判断注单能否被分享
 *
 * @see lottery接口设计文档
 *
 * @param {Object} playload - 有效载荷
 * @return {Object} Promise
 *
 * @since 2.0.0
 */
export async function checkAllowShare(playload) {
  return request({
    url: "/api/v2/betShare/checkAllowShare",
    method: "POST",
    data: playload,
    userId: true
  });
}
